/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsPulse: {
  name: 'pulse';
  data: string;
} = {
  name: 'pulse',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 2.5a.5.5 0 0 1 .464.314L10 11.654l1.536-3.84A.5.5 0 0 1 12 7.5h2a.5.5 0 0 1 0 1h-1.662l-1.874 4.686a.5.5 0 0 1-.928 0L6 4.346l-1.536 3.84A.5.5 0 0 1 4 8.5H2a.5.5 0 0 1 0-1h1.661l1.875-4.686A.5.5 0 0 1 6 2.5Z" fill="currentColor"/></svg>`,
};
